import React, { useCallback, useEffect, useState } from "react";
import ProcessLayout from "../Common/ProcessLayout";
import { API_URL, PROJECT_URL, RAWANSWERS_URL, TRANSCRIPT_URL, UPLOAD_URL } from "../../imports";
import axios from "axios";
import FilesToProcess from "../Common/FilesToProcess";
import Process from "../Common/Process";
import CurrentProcessLogs from "../Common/CurrentProcessLogs";
import FilewiseStatusLogs from "../Common/FilewiseStatusLogs";
import Popup from "../Common/Popup";
import { handleApiError } from "../Common/APIUtils";
import { formattedStartDateTime } from "../Common/CommonUtils";

function Raw() {
    const [startProcess, setStartProcess] = useState(false);
    const [backgroundProcess, setBackgroundProcess] = useState(false);
    const [filesData, setFilesData] = useState([]);
    const [fetchedFilesData, setFetchedFilesData] = useState([]);
    const [logsData, setLogsData] = useState([]);
    const [processedFiles, setProcessedFiles] = useState([]);
    const [unprocessedFiles, setUnProcessedFiles] = useState([]);
    const [serverStatus, setServerStatus] = useState(false);
    const [serviceUrl, setServiceUrl] = useState("");
    const [serverLoadState, setServerLoadState] = useState(true);
    const [Loader, setLoader] = useState(true);
    const [processOption, setProcessOption] = useState("normal");
    const [serverOFF, setServerOFF] = useState(false);
    const [startIndex, setStartIndex] = useState(undefined);
    const [endIndex, setEndIndex] = useState(undefined);
    const [rowSelection, setRowSelection] = useState({});
    const [fslstartIndex, setfslStartIndex] = useState(undefined);
    const [fslendIndex, setfslEndIndex] = useState(undefined);
    const [fslrowSelection, setfslRowSelection] = useState({});
    const [activeTab, setActiveTab] = useState(0);
    const [fslkey, setFslKey] = useState(0);
    const [activeParamCode, setActiveParamCode] = useState("");
    const [refinedRefreshKey, setRefinedRefreshKey] = useState(0);

    let [isOpenPopup, setIsOpenPopup] = useState(false);
    let [msg, setMsg] = useState(false);
    let [isSuccess, setIsSuccess] = useState(false);

    function closePopup() {
        setIsOpenPopup(false);
    }

    const openPopup = useCallback(() => {
        setIsOpenPopup(true);
    }, [setIsOpenPopup]);

    const handleStartProcess = async (data) => {
        
        if (processOption === "normal") {
            setStartProcess(true);
            setActiveTab(1);

            const initialFiles = data.map((file) => {
                return { ...file, status: null, creation_date: "" };
            });

            setFilesData(initialFiles);
            setLogsData([]);

            const currentLogs = [];
            const updatedProcessedFiles = [];
            const updatedUnprocessedFiles = [];

            for (let i = 0; i < data.length; i++) {
                let startdt = formattedStartDateTime();
                let file = data[i];
                file.status = "Inprogress";
                file.start_date_time = startdt;
                file.creation_date = "";
                setFilesData((prevData) => {
                    const newData = [...prevData];
                    newData[i] = file;
                    return newData;
                });
                console.log("User info:", {
                    client_id: localStorage.getItem("client_id"),
                    userId: sessionStorage.getItem("userId"),
                    user: localStorage.getItem("user"),
                    access_token_decoded: localStorage.getItem("access_token")
                });
                try {
                    const response = await axios.post(
                        `${RAWANSWERS_URL}/raw_process/${sessionStorage.getItem(
                            "projectCode"
                        )}`,
                        {
                            filename: file.filename,
                            id: file.id,
                            start_date_time: startdt,
                            client_id: localStorage.getItem("client_id") || sessionStorage.getItem("client_id")
                        },
                        {
                            headers: {
                                Authorization: `Bearer ${localStorage.getItem(
                                    "access_token"
                                )}`,
                            },
                        }
                    );
                    if (response.data.data.status === "success") {
                        // Update the status of the current file to "success"
                        file.status = "success";
                        file.response = response.data.data.response;
                        const date = new Date();
                        file.creation_date = date;
                        updatedProcessedFiles.push(file); // Add to processedFiles
                        currentLogs.push({
                            filename: file.filename,
                            creation_date: date,
                            start_date_time: startdt,
                            api_version:
                                response.data.data.response["api_version"],
                            ...response.data.data,
                        });
                        // for (let y = 0; y < response.data.data.length; y++) {
                        // currentLogs.push({
                        //     filename: file.filename,
                        //     creation_date: date,
                        //     api_version: response.data.data[y].response['api_version'],
                        //     ...response.data.data[y],
                        // });
                        // }
                    } else {
                        // Update the status of the current file to "error"
                        file.status = "error";
                        file.response = null;
                        const errordate = new Date();
                        file.creation_date = errordate;
                        file.start_date_time = startdt;
                        updatedUnprocessedFiles.push(file); // Add to unprocessedFiles
                        currentLogs.push({
                            filename: file.filename,
                            start_date_time: startdt,
                            creation_date: errordate,
                            ...response.data.data,
                        });
                        // for (let y = 0; y < response.data.data.length; y++) {
                        //     currentLogs.push({
                        //         filename: file.filename,
                        //         creation_date: errordate,
                        //         ...response.data.data[y],
                        //     });
                        // }
                    }
                } catch (error) {
                    // Update the status of the current file to "error"
                    file.status = "error";
                    file.response = null;
                    const errordate = new Date();
                    file.creation_date = errordate;
                    updatedUnprocessedFiles.push(file); // Add to unprocessedFiles

                    const errorMessage = handleApiError(error);
                    if (data.length < 2 && errorMessage === "InputError") {
                        setMsg(
                            error.response?.data?.status_message || errorMessage
                        );
                        setIsSuccess(false);
                        openPopup();
                    }
                    // Add this block
                    currentLogs.push({
                        filename: file.filename,
                        creation_date: errordate,
                        start_date_time: startdt,
                        status: "error",
                        response: errorMessage
                    });
                }

                setFilesData((prevData) => {
                    const newData = [...prevData];
                    newData[i] = file;
                    return newData;
                });
            }

            // Update the state with the updatedFiles array
            setLogsData(currentLogs);
            setProcessedFiles(updatedProcessedFiles); // Update processedFiles state
            setUnProcessedFiles(updatedUnprocessedFiles); // Update unprocessedFiles state
            setStartProcess(false);
            setActiveTab(3);
            setFslKey(prevKey => prevKey + 1);
            await new Promise(resolve => setTimeout(resolve, 1000));
            ReloadData();
        } else {
            // code for background process
            setBackgroundProcess(true);
            const fileIds = data.map((file) => file.id);
            try {
                const response = await axios.post(
                    `${RAWANSWERS_URL}/rawanswers/background/${sessionStorage.getItem(
                        "projectCode"
                    )}`,
                    {
                        files: fileIds,
                        serverState: serverOFF
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem(
                                "access_token"
                            )}`,
                        },
                    }
                );
                if (response) {
                    setMsg(response.data.message);
                    setServerStatus(response.data.serverStatus);
                    setIsSuccess(true);
                    openPopup();
                }
            } catch (error) {
                const errorMessage = handleApiError(error);
                setMsg(errorMessage);
                setIsSuccess(false);
                openPopup();
            }
            setBackgroundProcess(false);
            await new Promise(resolve => setTimeout(resolve, 1000));
            ReloadData();
        }
    };

    useEffect(() => {
        // const fetchTranscribedData = async () => {
        //     try {
        //         const response = await axios.get(
        //             // `${RAWANSWERS_URL}/rawanswers/closedtranscriptfiles/${sessionStorage.getItem(
        //             `${TRANSCRIPT_URL}/transcribe/rawanswers/closedtranscriptfiles/${sessionStorage.getItem(
        //                 "projectCode"
        //             )}`,
        //             {
        //                 headers: {
        //                     Authorization: `Bearer ${localStorage.getItem(
        //                         "access_token"
        //                     )}`,
        //                 },
        //             }
        //         );
        //         setFetchedFilesData(response.data.data);
        //     } catch (error) {
        //         const errorMessage = handleApiError(error);
        //         setMsg(errorMessage);
        //         setIsSuccess(false);
        //         openPopup();
        //     } finally {
        //         setTimeout(() => {
        //             setLoader(false);
        //         }, 100);
        //     }
        // };
        const fetchTranscribedData = async () => {
            try {
                const response = await axios.get(
                    // `${TRANSCRIPT_URL}/transcribe/rawanswers/closedtranscriptfiles/${sessionStorage.getItem("projectCode")}`,
                    `${UPLOAD_URL}/transcribe/rawanswers/closedtranscriptfiles/${sessionStorage.getItem("projectCode")}`,
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                        },
                        // params: {
                        //     include_pp_finalized: false  // ✅ ADD THIS: Exclude post-processing finalized files
                        // }
                    }
                );
                const currentClientId = localStorage.getItem("client_id");
                const currentUserName = localStorage.getItem("user");
                const filesWithParam = response.data.data.map(file => ({
                    ...file,
                    param_code: file.param_code || activeParamCode,
                    processed_by: file.processed_by
                    ? (file.processed_by === currentClientId ? currentUserName : file.processed_by)
                    : ""
                }));
                setFetchedFilesData(filesWithParam);
            } catch (error) {
                const errorMessage = handleApiError(error);
                setMsg(errorMessage);
                setIsSuccess(false);
                openPopup();
            } finally {
                setTimeout(() => {
                    setLoader(false);
                }, 100);
            }
        };
        
        // const fetchActiveParam = async () => {
        //     try {
        //         const response = await axios.get(
        //             `${PROJECT_URL}/projects/params/${sessionStorage.getItem("projectCode")}`,
        //             {
        //                 headers: {
        //                     Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        //                 },
        //             }
        //         );
        //         const activeParam = response.data.data.find(
        //             param => param.process_code === 'RAW' && param.status === true
        //         );
        //         if (activeParam) {
        //             setActiveParamCode(activeParam.param_code);
        //         }
        //     } catch (error) {
        //         console.error("Failed to fetch active param");
        //     }
        // };

        // const fetchStatus = async () => {
        //     try {
        //         const response = await axios.get(`${RAWANSWERS_URL}/instancemonitor`, {
        //             headers: {
        //                 Authorization: `Bearer ${localStorage.getItem(
        //                     "access_token"
        //                 )}`,
        //             },
        //             params: {
        //                 server_instance: "QA/DEMO",
        //             },
        //         });
        //         if (response) {
        //             setServerStatus(response.data.data[0].serverStatus);
        //             setServiceUrl(response.data.data[0].service_url);
        //         }
        //     } catch (error) {
        //         const errorMessage = handleApiError(error);
        //         if (errorMessage) {
        //             setServerStatus(false);
        //             setServiceUrl("");
        //         }
        //     } finally {
        //         setServerLoadState(false);
        //     }
        // };
        // const fetchData = async () => {
        //     try {
        //         // First fetch active param
        //         const paramResponse = await axios.get(
        //             `${PROJECT_URL}/projects/params/${sessionStorage.getItem("projectCode")}`,
        //             {
        //                 headers: {
        //                     Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        //                 },
        //             }
        //         );
        //         const activeParam = paramResponse.data.data.find(
        //             param => param.process_code === 'RAW' && param.status === true
        //         );
        //         const paramCode = activeParam ? activeParam.param_code : "";
                
        //         // Then fetch files
        //         const response = await axios.get(
        //             `${TRANSCRIPT_URL}/transcribe/rawanswers/closedtranscriptfiles/${sessionStorage.getItem("projectCode")}`,
        //             {
        //                 headers: {
        //                     Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        //                 },
        //             }
        //         );
                
        //         console.log("Active param code:", paramCode);
        //         console.log("Files from API:", response.data.data);
                
        //         const filesWithParam = response.data.data.map(file => {
        //             const updatedFile = {
        //                 ...file,
        //                 param_code: paramCode
        //             };
        //             console.log("Updated file:", updatedFile);
        //             return updatedFile;
        //         });
                
        //         console.log("Files with param:", filesWithParam);
        //         setFetchedFilesData(filesWithParam);
        //     } catch (error) {
        //         const errorMessage = handleApiError(error);
        //         setMsg(errorMessage);
        //         setIsSuccess(false);
        //         openPopup();
        //     } finally {
        //         setTimeout(() => {
        //             setLoader(false);
        //         }, 100);
        //     }
        // };
        
        // const fetchStatus = async () => {
        //     try {
        //         const response = await axios.get(`${RAWANSWERS_URL}/instancemonitor`, {
        //             headers: {
        //                 Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        //             },
        //             params: {
        //                 server_instance: "QA/DEMO",
        //             },
        //         });
        //         if (response) {
        //             setServerStatus(response.data.data[0].serverStatus);
        //             setServiceUrl(response.data.data[0].service_url);
        //         }
        //     } catch (error) {
        //         const errorMessage = handleApiError(error);
        //         if (errorMessage) {
        //             setServerStatus(false);
        //             setServiceUrl("");
        //         }
        //     } finally {
        //         setServerLoadState(false);
        //     }
        // };

        const fetchData = async () => {
            try {
                // Fetch active param
                const paramResponse = await axios.get(
                    `${PROJECT_URL}/projects/params/${sessionStorage.getItem("projectCode")}`,
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                        },
                    }
                );
                const activeParam = paramResponse.data.data.find(
                    param => param.process_code === 'RAW' && param.status === true
                );
                const paramCode = activeParam ? activeParam.param_code : "";
                
                // Fetch files
                const response = await axios.get(
                    `${UPLOAD_URL}/transcribe/rawanswers/closedtranscriptfiles/${sessionStorage.getItem("projectCode")}`,
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                        },
                    }
                );
                
                const filesWithParam = response.data.data.map(file => ({
                    ...file,
                    param_code: paramCode
                }));
                
                setFetchedFilesData(filesWithParam);
            } catch (error) {
                const errorMessage = handleApiError(error);
                setMsg(errorMessage);
                setIsSuccess(false);
                openPopup();
            } finally {
                setLoader(false);
            }
        };

        const fetchAlreadyProcessedFiles = async () => {
            try {
                const projectCode = sessionStorage.getItem("projectCode");
                const response = await axios.get(
                    `${RAWANSWERS_URL}/rawanswers/filewisestatusrpt/${projectCode}`,
                    // `${RAWANSWERS_URL}/filewisestatusrpt/${projectCode}`,
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                        },
                    }
                );
                const files = response.data?.data ?? response.data ?? [];

                // ✅ Set processed files
                const successFiles = files
                    // .filter(f => ["success", "SUCCESS", "Success"].includes(f.status))
                    .filter(f => f.status === "success")
                    .map(f => ({ ...f, filename: f.filename || f.file_name || f.name }));
                setProcessedFiles(successFiles);

                // ✅ Pre-populate logsData so table shows instead of "Please Start Process"
                // const allLogs = files.map(f => ({
                //     filename: f.filename || f.file_name || f.name,
                //     status: f.status,
                //     status_code: f.status_code,
                //     status_message: f.status_message,
                //     api_version: f.api_version || null,
                //     start_date_time: f.start_date_time || null,
                //     creation_date: f.creation_date || f.execution_date || null,
                // }));
                // if (allLogs.length > 0) setLogsData(allLogs);

            } catch (error) {
                console.log("Could not fetch processed files:", error.message);
            }
        };
    
        const fetchStatus = async () => {
            try {
                const response = await axios.get(`${RAWANSWERS_URL}/instancemonitor`, {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                    },
                    params: {
                        server_instance: "QA/DEMO",
                    },
                });
                if (response) {
                    setServerStatus(response.data.data[0].serverStatus);
                    setServiceUrl(response.data.data[0].service_url);
                }
            } catch (error) {
                setServerStatus(false);
                setServiceUrl("");
            } finally {
                setServerLoadState(false);
            }
        };
        
        fetchData();
        fetchStatus();
        // fetchActiveParam();
        fetchTranscribedData();
        fetchAlreadyProcessedFiles();
        // fetchStatus();
    }, [setFetchedFilesData, setServerStatus, openPopup]);

    // const ReloadData = useCallback(() => {
    //     setLoader(true);
    //     setRowSelection({});
    //     setStartIndex(undefined);
    //     setEndIndex(undefined);
    //     const reloadTranscribedData = async () => {
    //         try {
    //             const response = await axios.get(
    //                 // `${RAWANSWERS_URL}/rawanswers/closedtranscriptfiles/${sessionStorage.getItem(
    //                 `${TRANSCRIPT_URL}/transcribe/rawanswers/closedtranscriptfiles/${sessionStorage.getItem(
    //                     "projectCode"
    //                 )}`,
    //                 {
    //                     headers: {
    //                         Authorization: `Bearer ${localStorage.getItem(
    //                             "access_token"
    //                         )}`,
    //                     },
    //                 }
    //             );
    //             setFetchedFilesData(response.data.data);
    //         } catch (error) {
    //             const errorMessage = handleApiError(error);
    //             setMsg(errorMessage);
    //             setIsSuccess(false);
    //             openPopup();
    //         } finally {
    //             setTimeout(() => {
    //                 setLoader(false);
    //             }, 100);
    //         }
    //     };
    //     reloadTranscribedData();
    // }, [setFetchedFilesData, openPopup]);

    const ReloadData = useCallback(async (retryCount = 0, maxRetries = 3) => {
        setLoader(true);
        setRowSelection({});
        setStartIndex(undefined);
        setEndIndex(undefined);
        
        try {
            const response = await axios.get(
                // `${TRANSCRIPT_URL}/transcribe/rawanswers/closedtranscriptfiles/${sessionStorage.getItem(
                `${UPLOAD_URL}/transcribe/rawanswers/closedtranscriptfiles/${sessionStorage.getItem(
                    "projectCode"
                )}`,
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem(
                            "access_token"
                        )}`,
                    },
                }
            );
            
            // Check if we got data
            if (response.data && response.data.data) {
                const sortedData = [...response.data.data].sort((a, b) => {
                    // Strip the _finalizedfromPP suffix to get the base name for grouping
                    const getBaseName = (filename) =>
                        filename.replace(/_finalizedfromPP(\.\w+)?$/, '$1');

                    const baseA = getBaseName(a.filename || "");
                    const baseB = getBaseName(b.filename || "");

                    if (baseA === baseB) {
                        // Same base name: put the _finalizedfromPP file after the original
                        const isAFinalized = (a.filename || "").includes("_finalizedfromPP");
                        const isBFinalized = (b.filename || "").includes("_finalizedfromPP");
                        return isAFinalized - isBFinalized; // original (false=0) before finalized (true=1)
                    }

                    return baseA.localeCompare(baseB);
                });
                // setFetchedFilesData(response.data.data);
                setFetchedFilesData(sortedData);
                console.log(`Loaded ${response.data.data.length} files to process`);
                // ✅ ADD HERE — fetch already processed files to populate Processed tab
                try {
                    const projectCode = sessionStorage.getItem("projectCode");
                    const statusResponse = await axios.get(
                        `${RAWANSWERS_URL}/rawanswers/filewisestatusrpt/${projectCode}`,
                        {
                            headers: {
                                Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                            },
                        }
                    );
                    const files = statusResponse.data?.data ?? statusResponse.data ?? [];
                    const successFiles = files
                        // .filter(f => ["success", "SUCCESS", "Success"].includes(f.status))
                        .filter(f => f.status === "success")
                        .map(f => ({ ...f, filename: f.filename || f.file_name || f.name }));
                    setProcessedFiles(successFiles);
                    // const allLogs = files.map(f => ({
                    //     filename: f.filename || f.file_name || f.name,
                    //     status: f.status,
                    //     status_code: f.status_code,
                    //     status_message: f.status_message,
                    //     api_version: f.api_version || null,
                    //     start_date_time: f.start_date_time || null,
                    //     creation_date: f.creation_date || f.execution_date || null,
                    // }));
                    // if (allLogs.length > 0) setLogsData(allLogs);
                } catch (e) {
                    console.log("Could not refresh processed files:", e.message);
                }
            } else {
                console.warn("No data received from API");
                setFetchedFilesData([]);
            }
            
        } catch (error) {
            const errorMessage = handleApiError(error);
            
            // If we haven't exceeded max retries and it's a network error, retry
            if (retryCount < maxRetries && error.code === 'ERR_NETWORK') {
                console.log(`Retry ${retryCount + 1}/${maxRetries} after error: ${errorMessage}`);
                setTimeout(() => {
                    ReloadData(retryCount + 1, maxRetries);
                }, 1000 * (retryCount + 1)); // Exponential backoff
                return;
            }
            
            setMsg(errorMessage);
            setIsSuccess(false);
            openPopup();
            setFetchedFilesData([]); // Clear data on error
        } finally {
            setTimeout(() => {
                setLoader(false);
            }, 100);
        }
    }, [setFetchedFilesData, openPopup]);

    const tabs = [
        {
            id: 1,
            title: "Transcripted Files",
            content: (
                <FilesToProcess
                    serverStatus={serverStatus}
                    ReloadData={ReloadData}
                    items={fetchedFilesData}
                    startProcess={startProcess}
                    backgroundProcess={backgroundProcess}
                    setFilesData={handleStartProcess}
                    Loader={Loader}
                    setProcessOption={setProcessOption}
                    setServerOFF={setServerOFF}
                    startIndex={startIndex}
                    endIndex={endIndex}
                    setStartIndex={setStartIndex}
                    setEndIndex={setEndIndex}
                    rowSelection={rowSelection}
                    setRowSelection={setRowSelection}
                    process_code="RAW"
                />
            ),
        },
        {
            id: 2,
            title: "Raw Process",
            content: (
                <Process
                    startProcess={startProcess}
                    selectedFilesToProcess={filesData}
                />
            ),
        },
        {
            id: 3,
            title: "Logs",
            content: (
                // <CurrentProcessLogs
                //     logs={logsData}
                //     processedfiles={processedFiles}
                //     unprocessedfiles={unprocessedFiles}
                // />
                <CurrentProcessLogs
                    logs={logsData}
                    processedfiles={processedFiles}
                    unprocessedfiles={fetchedFilesData.filter(f =>
                        (f.status || "").toLowerCase() === "uploaded"
                    )}
                />
            ),
        },
        {
            id: 4,
            title: "All Files Status",
            content: (
                <FilewiseStatusLogs
                    // key={fslkey}
                    fetchFilewiseAPIURL={`rawanswers/filewisestatusrpt/${sessionStorage.getItem(
                        "projectCode"
                    )}`}
                    fileDetailsAPIURL={`rawanswers/fileDetailsLog/${sessionStorage.getItem(
                        "projectCode"
                    )}`}
                    // CloseAPIURL={`rawanswers/closefiles/${sessionStorage.getItem(
                    //     "projectCode"
                    // )}`}
                    CloseAPIURL={`rawanswers/closedrawfiles/${sessionStorage.getItem("projectCode")}`}
                    onFinalize={() => sessionStorage.setItem("refinedNeedsRefresh", "true")}
                    singleCSVDownloadAPI={`rawanswers/getdownloadcsv/${sessionStorage.getItem(
                        "projectCode"
                    )}`}
                    multipleCSVDownloadAPI={`rawanswers/downloadcsv/${sessionStorage.getItem(
                        "projectCode"
                    )}`}
                    multipleLogsDownloadAPI={`rawanswers/downloadlogs/${sessionStorage.getItem(
                        "projectCode"
                    )}`}
                    process_code="RAW"
                    startIndex={fslstartIndex}
                    endIndex={fslendIndex}
                    setStartIndex={setfslStartIndex}
                    setEndIndex={setfslEndIndex}
                    rowSelection={fslrowSelection}
                    setRowSelection={setfslRowSelection}
                    // onFinalize={() => setRefinedRefreshKey(k => k + 1)}
                />
            ),
        },
    ];

    return (
        <>
            <Popup
                isOpen={isOpenPopup}
                msg={msg}
                closeModal={closePopup}
                isSuccess={isSuccess}
            />
            <ProcessLayout
                startProcess={startProcess}
                tabs={tabs}
                server="VTI Service"
                serverStatus={serverStatus}
                serviceUrl={serviceUrl}
                serverLoadState={serverLoadState}
                batching={false}
                activeTab={activeTab}
                setActiveTab={setActiveTab}
            />
        </>
    );
}

export default Raw;
